import { jsx as o } from "react/jsx-runtime";
import { Notification as a } from "../../feedback/Notification/Notification.mjs";
import { CartShoppingIcon as r, BellIcon as s } from "../../icons/componentIcons.mjs";
const e = ({
  cartNotificationCount: i,
  isMobile: t = !1,
  onCartButtonClick: n
}) => /* @__PURE__ */ o(
  a,
  {
    "aria-label": i ? `Shopping Cart - contains ${i} transactions` : "Shopping Cart",
    notificationCount: i,
    onClick: n,
    icon: /* @__PURE__ */ o(r, { variant: "light", size: t ? "lg" : "md" }),
    size: t ? "md" : "sm",
    tooltipLabel: "Shopping Cart"
  }
), m = ({
  bellNotificationCount: i,
  isMobile: t = !1,
  onBellButtonClick: n
}) => /* @__PURE__ */ o(
  a,
  {
    "aria-label": i ? `Notifications - ${i} unread` : "Notifications",
    notificationCount: i,
    onClick: n,
    icon: /* @__PURE__ */ o(s, { variant: "light", size: t ? "lg" : "md" }),
    size: t ? "md" : "sm",
    tooltipLabel: "Notifications"
  }
);
export {
  m as BellNotificationButton,
  e as CartNotificationButton
};
